const path = require('path');

const languages = ['en', 'zh'];

const namespace = 'common';

/** @type {import("next-i18next").UserConfig} */
module.exports = {
  ns: [namespace],
  defaultNS: namespace,
  i18n: {
    defaultLocale: 'en',
    locales: languages,
  },
  defaultLanguage: 'en',
  detection: {
    order: ['cookie', 'header'],
  },
  localeDetection: true,
  otherLanguages: languages,
  localePath: path.resolve('./public/locales'),
  // A locale file edited while `next dev` runs is otherwise served stale until a restart.
  reloadOnPrerender: process.env.NODE_ENV === 'development',
  serializeConfig: false,
};
